export const properties = {
  codeOK: 200,
  codeERROR: 500,
  mensajeConfirmacionEliminacion: 'Está seguro que desea eliminar el registro?',
  mensajeConfirmacionDeshabilitacion: 'Está seguro de inhabilitar el registro?',
  mensajeConfirmacionHabilitacion: 'Está seguro de activar el registro?',
  errorComunicacionTitulo: 'Error',
  errorComunicacionMensaje:
    'Hubo un problema en la comunicación con el servidor, por favor inténtelo de nuevo en unos minutos',
  mensajeGrabadoOk: 'Información guardada correctamente.',

  //PATHS WS
  serviceLogin: '/auth/login',
  serviceDashboard: '/inicio/getData',
  serviceDashboardCountUserByGroupState: '/inicio/count-user-by-group-state',
  serviceDashboardCountDriverByGroupState:
    '/inicio/count-driver-by-group-state',
  serviceDashboardCountCarTripByGroupState:
    '/inicio/count-cartrip-by-group-state',
  serviceGetAllCompanyActive: '/company/getListActive',
  serviceGetAllCompany: '/company/getList',
  serviceGetAllCompanyPublic: '/company/public/getList',
  serviceCreateCompany: '/company/create',
  serviceUpdateCompany: '/company/update',
  serviceGetAllDriver: '/driver/getListByCom',
  serviceCreateDriver: '/driver/create',
  serviceCreateProspecto: '/driver/create-prospecto',
  serviceCreateDriverWithVehicle: '/driver/create-with-vehicle',
  serviceCreateProspectoWithVehicle: '/driver/create-prospecto-with-vehicle',
  serviceDeleteDriverPendingVehicle: '/driver/delete-driver-pending-vehicle',
  serviceUpdateDriver: '/driver/update',
  serviceDeleteDriver: '/driver/deleteDriver',
  serviceChangeStatusDriver: '/driver/change-status-driver',
  serviceUnlockDriver: '/driver/unlock-driver-phone',
  serviceGetDeleteDriver: '/driver/getList-status',
  serviceFilesDriver: '/document/createfilesdriver',
  serviceFilesProspecto: '/document/createfiles-prospecto',
  serviceFilesVehicle: '/document/createfilesvehicle',
  serviceGetAllTypeDocument: '/document/getAllTypeDocument',
  serviceGetDriver: '/driver/getDriver',
  serviceGetDriverSinAsignar: '/driver/getListDriverAsignar',
  serviceGetAllVehicle: '/vehicle/getList',
  serviceCreateVehicle: '/vehicle/create',
  serviceUpdateVehicle: '/vehicle/update',
  serviceDeleteVehicle: '/vehicle/delete',
  serviceUnassignVehicle: '/vehicle/unassign-vehicle',
  serviceGetVehicle: '/vehicle/getVehicleInfo',
  serviceVehicleChangeDriver: '/vehicle/change-driver',
  serviceDeleteFileDriver: '/document/deletefiledriver',
  serviceDeleteFileVehicle: '/document/deletefilevehicle',
  serviceDeleteUser: '/user/delete-account',
  serviceDeleteDriverAccount: '/driver/delete-account',
  serviceListCarTrip: '/cartrip/get-car-trip-by-dates',
  serviceListCarTripWeb: '/cartrip/get-car-trip-web-by-dates',
  serviceListStatusTrip: '/status-trip/list',
  serviceGetCarTripDetail: '/cartrip/get-car-trip-web-detail',
  serviceListUsers: '/user/get-user-by-dates',
  serviceListNotifications: '/notification/get-all',
  serviceCreateNotification: '/notification/save',
  serviceSendNotification: '/notification/send-notification',
  servicePoliticalDivisions: '/politicaldivision/GetAllPoliticalDivisions',
  serviceListPublicities: '/publicity/get-all-publicity',
  serviceUpdatePublicity: '/publicity/update-active-and-dates',
  serviceGetAllTypePublicity: '/type-publicity/get-all',
  serviceCreatePublicity: '/publicity/save',
  serviceGetAllStore: '/store/get-all',
  serviceCreateStore: '/store/create',
  serviceUpdateStore: '/store/update',
  serviceGetStore: '/store/get-by-id',
  serviceChangeStatusStore: '/store/change-status',
  serviceChangeFeaturedStore: '/store/change-featured',
  serviceGetMyStoreStatus: '/store/get-my-status',
  serviceGetMyLogo: '/store/get-my-logo',
  serviceGetAllStoreStatus: '/store-status/get-all',
  serviceGetAllProductCategories: '/product-category/get-all',
  serviceCreateProductCategory: '/product-category/create',
  serviceUpdateProductCategory: '/product-category/update',
  serviceChangeStatusProductCategory: '/product-category/change-active',
  serviceGetProductsByStore: '/product/get-by-store',
  serviceCreateProduct: '/product/create',
  serviceUpdateProduct: '/product/update',
  serviceChangeAvailabilityProduct: '/product/change-availability',
  serviceGetProductById: '/product/get-by-id',
  serviceMyStoreGet: '/my-store',
  serviceMyStoreUpdate: '/my-store/update',
  serviceMyStoreProducts: '/my-store/products',
  serviceMyStoreProductById: '/my-store/products/get-by-id',
  serviceMyStoreProductCreate: '/my-store/products/create',
  serviceMyStoreProductUpdate: '/my-store/products/update',
  serviceMyStoreProductAvailability: '/my-store/products/change-availability',
  serviceMyStoreCategories: '/my-store/categories',
  serviceGetUserWeb: '/userweb/get-user-web',
  serviceCreateUserWeb: '/userweb/create',
  serviceCreateTripWeb: '/cartrip/create-trip-web',
  serviceCreateAddressWeb: '/address-web/create',
  serviceCancelTripWeb: '/cartrip/cancel-trip-web',
  serviceFoodOrdersByStore: '/food-order/by-store',
  serviceFoodOrderUpdateStatus: '/food-order/update-status',
  serviceGetFoodOrderDetail: '/food-order/get-detail-by-id',
  serviceCalculatePriceTripWeb: '/cartrip/estimated-cost',
  serviiceCancelTripWeb: '/cartrip/cancel-car-trip-administrator'
};
